import "../Footer/Footer.css";
import SocialMedia from "../SocialMedia/SocialMedia";

function Footer() {
  return (
    <footer className="footer">
      <SocialMedia />
      <h5>Created By Andriana</h5>
    </footer>
  );
}
export default Footer;
